import { serviceErrorLogger } from './serviceErrorLogger';

const isPromise = <T>(value: unknown): value is Promise<T> => value instanceof Promise;

export const withServiceErrorCapture =
  <Args extends readonly unknown[], Return>(fn: (...args: Args) => Return) =>
  (...args: Args): Return => {
    try {
      const result = fn(...args);

      if (isPromise(result)) {
        return (result as Promise<unknown>).catch((e: unknown) => {
          serviceErrorLogger(e);
          throw e;
        }) as Return;
      }

      return result;
    } catch (e) {
      serviceErrorLogger(e);
      throw e;
    }
  };
